import { render, staticRenderFns } from "./DeadlineTypeSelect.vue?vue&type=template&id=5dedba9a&scoped=true&"
import script from "./DeadlineTypeSelect.vue?vue&type=script&lang=js&"
export * from "./DeadlineTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dedba9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
